import { ServiceBase } from '../api/ServiceBase';

const endpoint = 'tipos_pagamentos'


async function getTiposPagamentos() {
    try {
        var data = await ServiceBase.getByParams(`${endpoint}`, { 'limit': 10000 });
        return data;
    } catch (e) {
        throw e;
    }
}

export const TipoPagamentoService = {
    getTiposPagamentos
}